import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentMethodPage } from './payment-method.page';

const routes: Routes = [
  {
    path: '',
    component: PaymentMethodPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class PaymentMethodPageRoutingModule {}
